module.exports = __webpack_public_path__ + "img/gothic.febfc6e7.webp";